import { lazy } from "react";

//IMPORT DINÃMICO PARA DEIXAR O BUILD MENOR
export const COMPONENTES = {
  //Dashboard
  TDashboard: lazy(() => import("../pages/dashboard/dashboard.jsx")),

  //MENU MONITOR
  TMonitor_job: lazy(() => import("../pages/monitor/job/monitor_job.jsx")),
  TMonitor_job_log: lazy(
    () => import("../pages/monitor/job/monitor_job_log.jsx"),
  ),

  //MENU GESTORA
  TGestora_solicitacao_abas: lazy(
    () => import("../pages/gestora/solicitacao/gestora_abas.jsx"),
  ),
  TSolicitacao_cad_abas: lazy(
    () =>
      import("../pages/gestora/solicitacao/cadastro_solicitacao/solicitacao_cad_abas.jsx"),
  ),
  TCorrecao_solicitacao_abas: lazy(
    () =>
      import("../pages/gestora/solicitacao/aba_solicitacao/correcao_solicitacao/correcao_solicitacao_abas.jsx"),
  ),
  TGestora_contrato: lazy(
    () => import("../pages/gestora/contrato/gestora_contrato.jsx"),
  ),

  //MENU CADASTRO
  TEmpresa: lazy(() => import("../pages/cadastro/pessoa/empresa/empresa.jsx")),
  TFilial: lazy(() => import("../pages/cadastro/pessoa/filial/filial.jsx")),
  TFornecedor: lazy(
    () => import("../pages/cadastro/pessoa/fornecedor/fornecedor.jsx"),
  ),
  TCentro_custo: lazy(
    () => import("../pages/cadastro/centro_custo/centro_custo.jsx"),
  ),
  TConta_tenant: lazy(
    () => import("../pages/cadastro/conta_tenant/conta_tenant.jsx"),
  ),

  TArea: lazy(() => import("../pages/cadastro/area/area.jsx")),
  TFeriado: lazy(() => import("../pages/cadastro/feriado/feriado.jsx")),
  TAlcada: lazy(() => import("../pages/cadastro/alcada/alcada.jsx")),
  TGrupo_produto: lazy(
    () => import("../pages/cadastro/grupo_produto/grupo_produto.jsx"),
  ),
  TPrevisao_variacao: lazy(
    () => import("../pages/cadastro/previsao/previsao_variacao.jsx"),
  ),

  //MENU IMPORTAÇÃO
  TImportacao: lazy(() => import("../pages/importacao/importacao.jsx")),

  //MENU CONSULTA
  TResumo_venda: lazy(
    () => import("../pages/consulta/resumo_venda/resumo_venda.jsx"),
  ),
  TMeta: lazy(() => import("../pages/consulta/meta/meta.jsx")),
  TNota_entrada: lazy(() => import("../pages/consulta/nota/nota_entrada.jsx")),
  TIndice_reajuste: lazy(
    () => import("../pages/consulta/indice_reajuste/indice_reajuste.jsx"),
  ),

  //MENU ACESSO
  TPerfil: lazy(() => import("../pages/acesso/perfil/perfil.jsx")),
  TUsuario: lazy(() => import("../pages/acesso/usuario/usuario.jsx")),

  TTela_liberacao: lazy(
    () => import("../pages/acesso/tela/tela_liberacao.jsx"),
  ),
  TAutorizacao_liberacao: lazy(
    () => import("../pages/acesso/autorizacao/autorizacao_liberacao.jsx"),
  ),
  TAutorizacao_liberacao_log: lazy(
    () => import("../pages/acesso/autorizacao/autorizacao_liberacao_log.jsx"),
  ),
  TNotificacao_liberacao: lazy(
    () => import("../pages/acesso/notificacao/notificacao_liberacao.jsx"),
  ),

  //MENU CONFIGURACAO
  TParametrizacao: lazy(
    () => import("../pages/configuracao/parametrizacao/parametrizacao.jsx"),
  ),

  //### SYSTEM ###
  //MENU SYS CADASTRO
  TSys_Tenant: lazy(() => import("../pages/system/cadastro/tenant/tenant.jsx")),

  TSys_Plano_conta: lazy(
    () => import("../pages/system/cadastro/plano_conta/plano_conta.jsx"),
  ),

  TSys_Grupo_conta: lazy(
    () => import("../pages/system/cadastro/grupo_conta/grupo_conta.jsx"),
  ),

  TSys_Conta: lazy(() => import("../pages/system/cadastro/conta/conta.jsx")),

  TSys_Banco: lazy(() => import("../pages/system/cadastro/banco/banco.jsx")),

  TSys_Imposto: lazy(
    () => import("../pages/system/cadastro/imposto/imposto.jsx"),
  ),

  TSys_Forma_pagamento: lazy(
    () =>
      import("../pages/system/cadastro/forma_pagamento/forma_pagamento.jsx"),
  ),

  TSys_Tipo_documento: lazy(
    () => import("../pages/system/cadastro/tipo_documento/tipo_documento.jsx"),
  ),

  TSys_Indice_reajuste: lazy(
    () =>
      import("../pages/system/cadastro/indice_reajuste/indice_reajuste.jsx"),
  ),

  //MENU SYS CONSULTA
  TSys_Usuario: lazy(
    () => import("../pages/system/consulta/usuario/usuario.jsx"),
  ),

  TSys_Usuario_conectado: lazy(
    () =>
      import("../pages/system/consulta/usuario_conectado/usuario_conectado.jsx"),
  ),

  TSys_Log_alteracao: lazy(
    () => import("../pages/system/consulta/log_alteracao/log_alteracao.jsx"),
  ),

  TSys_Log_servidor: lazy(
    () => import("../pages/system/consulta/log_servidor/log_servidor.jsx"),
  ),
  TSys_Log_leitura_documento_ia: lazy(
    () =>
      import("../pages/system/consulta/log_leitura_documento_ia/log_leitura_documento_ia.jsx"),
  ),
  TSys_Changelog: lazy(
    () => import("../pages/system/consulta/changelog/changelog.jsx"),
  ),

  //MENU SYS CONFIGURACAO
  TSys_Log_alteracao_param: lazy(
    () =>
      import("../pages/system/configuracao/log_alteracao/log_alteracao_param.jsx"),
  ),
};

// import TAutorizacao_liberacao from "../pages/acesso/autorizacao/autorizacao_liberacao.jsx";
// import TAutorizacao_liberacao_log from "../pages/acesso/autorizacao/autorizacao_liberacao_log.jsx";
// import TPerfil from "../pages/acesso/perfil/perfil.jsx";
// import TTela_liberacao from "../pages/acesso/tela/tela_liberacao.jsx";
// import TUsuario from "../pages/acesso/usuario/usuario.jsx";
// import TAlcada from "../pages/cadastro/alcada/alcada.jsx";
// import TArea from "../pages/cadastro/area/area.jsx";
// import TCentro_custo from "../pages/cadastro/centro_custo/centro_custo.jsx";
// import TFeriado from "../pages/cadastro/feriado/feriado.jsx";
// import TGrupo_produto from "../pages/cadastro/grupo_produto/grupo_produto.jsx";
// import TIndice_reajuste from "../pages/cadastro/indice_reajuste/indice_reajuste.jsx";
// import TEmpresa from "../pages/cadastro/pessoa/empresa/empresa.jsx";
// import TFilial from "../pages/cadastro/pessoa/filial/filial.jsx";
// import TFornecedor from "../pages/cadastro/pessoa/fornecedor/fornecedor.jsx";
// import TPrevisao_variacao from "../pages/cadastro/previsao/previsao_variacao.jsx";
// import TParametrizacao from "../pages/configuracao/parametrizacao/parametrizacao.jsx";
// import TMeta from "../pages/consulta/meta/meta.jsx";
// import TResumo_venda from "../pages/consulta/resumo_venda/resumo_venda.jsx";
// import TDashboard from "../pages/dashboard/dashboard.jsx";
// import TGestora_contrato from "../pages/gestora/contrato/gestora_contrato.jsx";
// import TSolicitacao_cad_abas from "../pages/gestora/solicitacao/cadastro_solicitacao/solicitacao_cad_abas.jsx";
// import TGestora_solicitacao_abas from "../pages/gestora/solicitacao/gestora_solicitacao_abas.jsx";
// import TImportacao from "../pages/importacao/importacao.jsx";
// import TMonitor_job from "../pages/monitor/job/monitor_job.jsx";
// import TMonitor_job_log from "../pages/monitor/job/monitor_job_log.jsx";
// import TBanco from "../pages/system/cadastro/banco/banco.jsx";
// import TConta from "../pages/system/cadastro/conta/conta.jsx";
// import TGrupo_conta from "../pages/system/cadastro/grupo_conta/grupo_conta.jsx";
// import TLog_alteracao_param from "../pages/system/cadastro/log_alteracao/log_alteracao_param.jsx";
// import TSys_Plano_conta from "../pages/system/cadastro/plano_conta/plano_conta.jsx";
// import TTenant from "../pages/system/cadastro/tenant/tenant.jsx";
// import TSys_Usuario from "../pages/system/cadastro/usuario/usuario.jsx";

// // Mapeamento dos componentes
// export const COMPONENTES = {
//   //Dashboard
//   TDashboard,

//   //MENU MONITOR
//   TMonitor_job,
//   TMonitor_job_log,

//   //MENU GESTORA
//   TGestora_solicitacao_abas,
//   TSolicitacao_cad_abas,
//   TGestora_contrato,

//   //MENU CADASTRO
//   TEmpresa,
//   TFilial,
//   TFornecedor,
//   TCentro_custo,
//   TArea,
//   TFeriado,
//   TAlcada,
//   TGrupo_produto,
//   TIndice_reajuste,
//   TPrevisao_variacao,
//   TImportacao,

//   //MENU CONSULTA
//   TResumo_venda,
//   TMeta,

//   //MENU ACESSO
//   TPerfil,
//   TUsuario,

//   TTela_liberacao,
//   TAutorizacao_liberacao,
//   TAutorizacao_liberacao_log,

//   //MENU CONFIGURACAO
//   TParametrizacao,

//   //MENU SYSTEM
//   TTenant,
//   TSys_Usuario,
//   TSys_Plano_conta,
//   TGrupo_conta,
//   TConta,
//   TBanco,
//   TLog_alteracao_param,
// };
